module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || '4tis9e76',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
